export default "__VITE_ASSET__BS62byhH__"